/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringFilterItemOutput
 */
export interface StringFilterItemOutput {
    /**
     * 
     * @type {string}
     * @memberof StringFilterItemOutput
     */
    displayText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringFilterItemOutput
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringFilterItemOutput
     */
    isEffective?: boolean;
}

export function StringFilterItemOutputFromJSON(json: any): StringFilterItemOutput {
    return StringFilterItemOutputFromJSONTyped(json, false);
}

export function StringFilterItemOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringFilterItemOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayText': !exists(json, 'displayText') ? undefined : json['displayText'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'isEffective': !exists(json, 'isEffective') ? undefined : json['isEffective'],
    };
}

export function StringFilterItemOutputToJSON(value?: StringFilterItemOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayText': value.displayText,
        'value': value.value,
        'isEffective': value.isEffective,
    };
}


